import * as Contentful from 'contentful'
import * as CFRichTextTypes from '@contentful/rich-text-types'
import { TypeAssetImage } from './asset-image'
import { TitleSize } from './typography'
import { ItemFeatureHighlightDecoration } from './item-feature-highlight-decoration'

export enum DescriptionSize {
  Large = 'large',
  Medium = 'medium',
}

export enum EyebrowStyle {
  Large = 'large',
  Medium = 'medium',
}

export enum IconSpacer {
  Large = 'large',
  Medium = 'medium',
}

export enum TitleSpacer {
  None = 'none',
}

export interface TypeItemFeatureHighlightFields {
  internalName: Contentful.EntryFields.Symbol
  eyebrowTitle?: CFRichTextTypes.Document
  eyebrowStyle?: EyebrowStyle
  title?: CFRichTextTypes.Document
  description?: CFRichTextTypes.Document
  descriptionSize?: DescriptionSize
  iconAsset?: TypeAssetImage
  iconSpacer?: IconSpacer
  titleSpacer?: TitleSpacer
  titleSize?: TitleSize
  decoration?: ItemFeatureHighlightDecoration
}

export type TypeItemFeatureHighlight = Contentful.Entry<TypeItemFeatureHighlightFields>
